import { Component, inject, input } from '@angular/core';
import { SearchableStrategy } from '../../../../shared/models/searchable-strategy.model';
import { Observable } from 'rxjs';
import {
	ApiRequestOrdering,
	ApiPaginatedResponse,
	VehicleColorSearchDto,
	ModulesEnum,
} from '@splitsecondconnect/ultramarine-shared';
import { SelectItem } from '../../../../shared/models/select-item.type';
import { VehicleColorService } from '../vehicles-record/components/vehicles-color/services/vehicle-color.service';
import { mapDtoToModelVehicleColors } from '../vehicles-record/components/vehicles-color/mappers/search-dto-to-model.mapper';
import { ListDisplaySectionItemComponent } from '../../../../shared/components/list-display-section/components/list-display-section-item/list-display-section-item.component';

@Component({
	selector: 'app-vehicle-color-selected-item',
	imports: [ListDisplaySectionItemComponent],
	host: {
		class: 'w-full',
	},
	template: `
		<app-list-display-section-item
			[plain]="true"
			class="w-full"
			[item]="item()"
			[module]="item().module">
		</app-list-display-section-item>
	`,
})
class VehicleColorSelectedItemComponent {
	item = input<SelectItem<VehicleColorSearchDto>>();
	plain = input<boolean>();
	moduleEnum = ModulesEnum;
}

export class VehicleColorSearchStrategy
	implements SearchableStrategy<VehicleColorSearchDto>
{
	#vehicleColorsService = inject(VehicleColorService);

	getSearchResults(
		searchQuery: string,
		searchQueryIds: number[],
		pageSize: number,
		searchFilters: any,
		page: number,
		ordering: ApiRequestOrdering,
	): Observable<ApiPaginatedResponse<any[]>> {
		return this.#vehicleColorsService.getSearchResults(
			searchQuery,
			searchQueryIds,
			pageSize,
			searchFilters,
			page,
			ordering,
		);
	}

	selectedItemDisplay = VehicleColorSelectedItemComponent;

	mapDtoToModel(
		items: VehicleColorSearchDto[],
	): SelectItem<VehicleColorSearchDto>[] {
		return mapDtoToModelVehicleColors(items);
	}
}
